import { render, staticRenderFns } from "./ArrangeDoctor.vue?vue&type=template&id=0c6e18a1"
import script from "./ArrangeDoctor.vue?vue&type=script&lang=js"
export * from "./ArrangeDoctor.vue?vue&type=script&lang=js"
import style0 from "./ArrangeDoctor.vue?vue&type=style&index=0&id=0c6e18a1&prod&scope=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports